import { useQuery } from "@tanstack/react-query";
import { useApiClient, useHttpClient } from "../../../lib/http";
import { TranslationType } from "./types";

const INVALID_VARIANTS = ["MANDATORY", "SPECIFIC_DATE", "PER_DAY_MANDATORY"];

export const useExtras = (propertyTicker: string) => {
  const httpClientExtras = useHttpClient("", { usePropertyHeader: true });

  const { data: extras } = useQuery({
    queryKey: ["extras", propertyTicker],
    queryFn: async () => {
      const response = await httpClientExtras.get<any>(`/v6/api/v1/${propertyTicker}/extra`);
      return response
        .filter(item => !INVALID_VARIANTS.includes(item.variant) && item.type !== "UNIT")
        .map((item: any) => ({
          ...item,
          name: item.ticker,
          translations: fromArrayToObjet(item.translations),
        }));
    },
    staleTime: 1000 * 60 * 2,
  });

  return { extras };
};

export const usePromotions = (propertyTicker: string) => {
  const httpClientPromos = useApiClient();

  const { data: promotions } = useQuery({
    queryKey: ["promotions", propertyTicker],
    queryFn: async () => {
      const response = await httpClientPromos.get<any>(
        `/api/property/${propertyTicker}/engine/administration/promo`
      );
      return response
        .filter((it: any) => isPromotionWithRate(it))
        .map((item: any) => ({
          ...item,
          name: item.ticker,
          translations: fromArrayToObjet(item.translations),
        }));
    },
    staleTime: 1000 * 60 * 2,
  });

  return { promotions };
};

enum PROMO_RATE_TYPE {
  CONSTANT = "CONSTANT",
  PERCENTAGE = "PERCENTAGE",
  FORMULA = "FORMULA",
  DISC_FIX_STAY = "DISC_FIX_STAY",
  GIVE_NIGHT = "GIVE_NIGHT",
  HIGHLIGHT_MESSAGE = "HIGHLIGHT_MESSAGE",
}

function fromArrayToObjet(
  translations: TranslationType[]
): { [key: string]: { name: string; description: string; locale: string } } {
  return translations.reduce(
    (acc, { locale, name, description }) => ({
      ...acc,
      [locale]: { name, description, locale },
    }),
    {}
  );
}

function isPromotionWithRate(promo: any) {
  if (promo?.rate?.rateType === PROMO_RATE_TYPE.PERCENTAGE) {
    return Boolean(promo.rate?.rateValue?.value);
  }
  if (promo?.rate?.rateType === PROMO_RATE_TYPE.CONSTANT) {
    return Boolean(promo.rate?.rateValue?.value?.amount);
  }
  return promo;
}
